/*
 * @Author: 刘小博
 * @Date: 2023-02-03 14:58:56
 * @LastEditTime: 2023-04-13 14:13:18
 * @LastEditors: 肖玲
 * @Description:
 * 产品库
 */
const productLibraryRouter = [
  // 产品管理
  {
    path: '/masterDataSystem/goods-manage',
    name: 'goodsManage',
    component: () =>
      import(
        /*webpackChunkName:"goods" */
        // '@/views/masterDataSystem/goods/Manage.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '产品管理',
    },
  },
  // 产品集采管理
  {
    path: '/masterDataSystem/centerazed-purchases-goods/page',
    name: 'centerazedPurchasesGoods',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        '@/views/master-data/master-data-maintain/product-library/product-manage/centralized-purchases-goods/Page.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '集采产品管理',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
      ],
    },
  },
  // 产品集采管理新增与编辑
  {
    path: '/masterDataSystem/centerazed-purchases-goods/edit/:meta_type/:goods_id',
    name: 'centerazedPurchasesGoodsEdit',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        '@/views/master-data/master-data-maintain/product-library/product-manage/centralized-purchases-goods/edit.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '集采产品管理',
      breadcrumb: [
        {
          title: '集采产品管理',
          name: 'centerazedPurchasesGoods',
        },
      ]
    }
  },
  // 产品添加
  {
    path: '/masterDataSystem/goods-add/:meta_type',
    name: 'goodsAdd',
    component: () =>
      import(
        /*webpackChunkName:"goods" */
        // '@/views/masterDataSystem/goods/Edit.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/Add.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      isMoreMeta: true,
      1: {
        title: '产品新增',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
        ],
      },
      2: {
        title: '产品编辑',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
        ],
      },
    },
  },
  //物料列表
  {
    path: '/masterDataSystem/material/page',
    name: 'MaterialList',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        '@/views/master-data/master-data-maintain/product-library/product-manage/material/Page.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '物料列表',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
      ],
    },
  },

  //物料列表 维护业务品规
  {
    path: '/masterDataSystem/material/import-spec',
    name: 'MaterialImportSpec',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        '@/views/master-data/master-data-maintain/product-library/product-manage/material/ImportSpec.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '维护业务品规',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
        {
          title: '物料列表',
          name: 'MaterialList',
        },
      ],
    },
  },

  // 产品导入
  {
    path: '/masterDataSystem/goods-import',
    name: 'goodsImport',
    component: () =>
      import(
        /*webpackChunkName:"goods" */
        // '@/views/masterDataSystem/goods/ClientImport.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/Import.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '导入产品',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
      ],
    },
  },
  // 产品分类
  {
    path: '/masterDataSystem/goods-category',
    name: 'masterDataSystemGoodsCategory',
    component: () =>
      import(
        /*webpackChunkName:"goods" */
        // '@/views/masterDataSystem/goods/Category.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/Category.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '产品分类',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
      ],
    },
  },
  //工业库存
  {
    path: '/masterDataSystem/goods-stock',
    name: 'masterDataSystemGoodssStock',
    component: () =>
      import(
        /*webpackChunkName:"goods" */
        // '@/views/masterDataSystem/goods/goodsStock.vue'  // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/Stock.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '工业库存',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
      ],
    },
  },
  // 产品单价设置
  {
    path: '/masterDataSystem/goods-unit-price-setting',
    name: 'masterDataSystemGoodsUnitPriceSetting',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/UnitPriceSetting.vue'  // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/unit-price-setting/Page.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '产品单价设置',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
      ],
    },
  },
  // 价格优先级设置
  {
    path: '/masterDataSystem/goods-price-priority-setting',
    name: 'masterDataSystemGoodsPricePrioritySetting',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '../views/masterDataSystem/goods/unitPriceSetting/PricePrioritySetting.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/unit-price-setting/PricePrioritySetting.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '价格优先级设置',
      breadcrumb: [
        {
          title: '产品管理',
          name: 'goodsManage',
        },
        {
          title: '产品单价设置',
          name: 'masterDataSystemGoodsUnitPriceSetting',
        },
      ],
    },
  },

  // 价 meta_type 1-处方,2-药店,3-商务 4-考核
  {
    path: '/masterDataSystem/goods-unit-price-page/:meta_type',
    name: 'masterDataSystemGoodsUnitPricePage',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/Page.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/unit-price-setting/setting/Page.vue' // 待删除
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      isMoreMeta: true,
      1: {
        title: '处方中标价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
        ],
      },
      2: {
        title: '药店零售价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
        ],
      },
      3: {
        title: '商务合同价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
        ],
      },
      4: {
        title: '考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
        ],
      },
    },
  },
  // 价批量设置 meta_type 1-处方,2-药店,3-商务, 4-考核
  {
    path: '/masterDataSystem/goods-price-batch-setting/:meta_type/:set_way/:title',
    name: 'masterDataSystemGoodsPriceBatchSetting',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/BatchSetting.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/unit-price-setting/setting/BatchSetting.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      isMoreMeta: true,
      1: {
        title: '批量设置处方中标价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '处方中标价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 1,
            },
          },
        ],
      },
      2: {
        title: '批量设置药店零售价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '药店零售价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 2,
            },
          },
        ],
      },
      3: {
        title: '批量设置商务合同价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '商务合同价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 3,
            },
          },
        ],
      },
      4: {
        title: '批量设置考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
      5: {
        title: '批量设置自定义单价1',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '批量设置自定义单价1',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 5,
            },
          },
        ],
      },
      6: {
        title: '批量设置自定义单价2',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '批量设置自定义单价2',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 6,
            },
          },
        ],
      },
      7: {
        title: '批量设置自定义单价3',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '批量设置自定义单价3',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 7,
            },
          },
        ],
      },
      8: {
        title: '批量设置自定义单价4',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '批量设置自定义单价4',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 8,
            },
          },
        ],
      },
      9: {
        title: '批量设置自定义单价5',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '批量设置自定义单价5',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 9,
            },
          },
        ],
      },
    },
  },
  // 价 meta_type 1-处方,2-药店,3-商务(导出)
  {
    path: '/masterDataSystem/goods-unit-price-export/:meta_type',
    name: 'masterDataSystemGoodsUnitPriceExport',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/exportPrice.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-manage/unit-price-setting/setting/Export.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      isMoreMeta: true,
      1: {
        title: '处方中标价导出',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '处方中标价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 1,
            },
          },
        ],
      },
      2: {
        title: '药店零售价导出',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '药店零售价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 2,
            },
          },
        ],
      },
      3: {
        title: '商务合同价导出',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '商务合同价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 3,
            },
          },
        ],
      },
      4: {
        title: '考核价导出',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
    },
  },

  // 产品单价设置-新
  {
    path: '/masterDataSystem/goods-unit-price-setting-new',
    name: 'masterDataSystemNewGoodsUnitPriceSetting',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/UnitPriceSettingNew.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-unit-price-setting/Page.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '产品单价设置',
    },
  },
  // 产品单价设置-新 配置
  {
    path: '/masterDataSystem/goods-unit-price-setting-sort',
    name: 'masterDataSystemNewGoodsUnitPriceSettingSort',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/UnitPriceSettingSort.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-unit-price-setting/Setting.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '产品单价设置',
    },
  },
  // 产品单价设置-新 价格优先级设置
  {
    path: '/masterDataSystem/goods-price-priority-setting-new',
    name: 'masterDataSystemGoodsPricePrioritySettingNew',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/PricePrioritySettingNew.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-unit-price-setting/PricePrioritySetting.vue'
      ),
    meta: {
      SecondaryMenu: '系统配置', //二级菜单
      title: '产品单价配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'goodsManage',
        },
      ],
    },
  },
  // 生效价 meta_type 1-处方,2-药店,3-商务
  {
    path: '/masterDataSystem/goods-effective-price/:meta_type/:way/:province/:good/:city/:client_id/:batch',
    name: 'masterDataSystemGoodsEffectivePrice',
    component: () =>
      import(
        /*webpackChunkName:"unitPriceOfProduct" */
        // '@/views/masterDataSystem/goods/unitPriceSetting/EffectivePrice.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/product-unit-price-setting/Details.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      isMoreMeta: true,
      1: {
        title: '生效中标价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '处方中标价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 1,
            },
          },
        ],
      },
      2: {
        title: '生效零售价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '药店零售价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 2,
            },
          },
        ],
      },
      3: {
        title: '生效合同价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '商务合同价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 3,
            },
          },
        ],
      },
      4: {
        title: '生效考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
      5: {
        title: '生效考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
      6: {
        title: '生效考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
      7: {
        title: '生效考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
      8: {
        title: '生效考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
      9: {
        title: '生效考核价',
        breadcrumb: [
          {
            title: '产品管理',
            name: 'goodsManage',
          },
          {
            title: '产品单价设置',
            name: 'masterDataSystemNewGoodsUnitPriceSetting',
          },
          {
            title: '考核价',
            name: 'masterDataSystemGoodsUnitPricePage',
            params: {
              meta_type: 4,
            },
          },
        ],
      },
    },
  },

  // 竞品维护
  {
    path: '/masterDataSystem/competitive-maintain',
    name: 'CompetitiveMaintain',
    component: () =>
      import(
        /*webpackChunkName:"CompetitiveMaintain" */
        // '@/views/masterDataSystem/CompetitiveMaintain.vue' // 待删除
        '@/views/master-data/master-data-maintain/product-library/competitive-maintain-manage/Page.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '竞品信息管理',
    },
  },
  // 竞品维护 添加
  {
    path: '/masterDataSystem/competitive-addRedact/:id',
    name: 'CompetitiveAddRedact',
    component: () =>
      import(
        /*webpackChunkName:"CompetitiveMaintain" */
        // '@/views/masterDataSystem/CompetitiveAddRedact.vue'// 待删除
        '@/views/master-data/master-data-maintain/product-library/competitive-maintain-manage/Add.vue'
      ),
    meta: {
      SecondaryMenu: '产品库', //二级菜单
      title: '添加竞品',
    },
  },
]

export default productLibraryRouter
